import React from "react";
import { MutatingDots } from "react-loader-spinner";
import LakeviewLoader from '../lakeview/loader/LakeviewLoader';

const Loader = ({ loader, setLoader }) => {
  return (
    <>
      {/*<MutatingDots*/}
      {/*  color="#ff5205"*/}
      {/*  secondaryColor="#ff5205"*/}
      {/*  visible={loader}*/}
      {/*  height={100}*/}
      {/*  width={100}*/}
      {/*  wrapperClass={"loading"}*/}
      {/*/>*/}

      <LakeviewLoader loader={loader} />

    </>
  );
}

export default Loader;